export default {
  'menu.welcome': 'Welcome',
  'menu.home': 'Home',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  // Platform Dashboard (overview merged into Ecosystem Health)
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Ecosystem Health',
  'menu.dashboard.monitor': 'Monitor & Rankings',
  'menu.dashboard.workplace': 'Business Sandbox',
  // Infrastructure & Assets
  'menu.infrastructure': 'Infrastructure & Assets',
  'menu.infrastructure.gateway': 'Model Gateway',
  'menu.infrastructure.templates': 'Official Templates',
  'menu.infrastructure.tools': 'Plugins & Knowledge Base',
  // Market & Commercialization
  'menu.market': 'Market & Commercial',
  'menu.market.categories': 'Categories',
  'menu.market.approval': 'Approval Flow',
  'menu.market.recommend': 'Recommendations',
  'menu.market.sku': 'Pricing (SKU)',
  'menu.market.independent-deploy': 'Independent Deploy',
  'menu.market.settlement': 'Settlement',
  'menu.market.points': 'Points Management',
  'menu.market.pricing-rules': 'Pricing Rules',
  'menu.market.membership': 'Membership Plans',
  // Operate: Workgroups (view all agents within each group)
  'menu.operate': 'Operate',
  'menu.operate.workgroups': 'Workgroups',
  'menu.operate.vip-orders': 'VIP Orders',
  'menu.operate.redeem-codes': 'Redeem Codes',
  // User & Creator 360
  'menu.user-creator': 'User & Creator',
  'menu.user-creator.users': 'User Control',
  'menu.user-creator.creator': 'Creator Capacity',
  // Quality & Evolution
  'menu.quality': 'Quality & Evolution',
  'menu.quality.badcase': 'Dialogue QA',
  'menu.quality.prompt-repo': 'Prompt Repo',
  'menu.quality.ab-test': 'A/B Lab',
  // Compliance & Security
  'menu.compliance': 'System & Audit',
  'menu.compliance.admin-users': 'Admin Users',
  'menu.compliance.system-logs': 'System Logs',
  // Account & System
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Settings',
  'menu.account.logout': 'Logout',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
};
